import { useState, useEffect, useRef } from "react";
import "./OrderList.css";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../Loader/Loader";
import Button from "../../components/button/Button";
import Navbar from "../../components/navbar/navbar";
import { Segmented, notification, Modal } from "antd";
import secureLocalStorage from "react-secure-storage";
import { connectWebSocket, disconnectWebSocket } from "../../services/websocket";

import {
  list_restaurant_orders_by_restaurant_id,
  update_order,
} from "../../services/order";

export default function OrderList() {
  const [isModalVisible, setIsModalVisible] = useState(true);
  const isModalVisibleRef = useRef(isModalVisible);

  const [activeOrders, setActiveOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [selectedSegmented, setSelectedSegmented] = useState(
    "Pedidos ativos"
  );
  const restaurant = secureLocalStorage.getItem("restaurant");
  const [api, contextHolder] = notification.useNotification();
  let soundInterval = null;

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
          .then(registration => {
            console.log('Service Worker registrado com sucesso:', registration);
          })
          .catch(error => {
            console.log('Falha ao registrar o Service Worker:', error);
          });
      });
    }
    connectWebSocket((data) => {
      GetAllOrders()
    });

    return () => {
      disconnectWebSocket();
    };
  }, []);

  useEffect(() => {
    const checkErrorOrders = () => {
      console.log("activeOrders ->", activeOrders);
      const errorOrders = activeOrders.filter(
        order => order.status === "error_pdv" || order.status === "error_payment"
      );

      if (errorOrders.length > 0) {
        showNotificationWithSound();
      }
    };

    const interval = setInterval(checkErrorOrders, 60000);
    return () => clearInterval(interval);
  }, [activeOrders]);

  useEffect(() => {
    GetAllOrders();
    const intervalId = setInterval(() => {
      GetAllOrders();
    }, 3 * 60 * 1000); 
    return () => clearInterval(intervalId);
  }, []);
  
  const requestNotificationPermission = () => {
    if ("Notification" in window) {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          console.log("Permissão para notificação concedida!");
        } else {
          console.log("Permissão para notificação negada");
        }
      });
    } else {
      console.log("Notificações não são suportadas neste navegador");
    }
  };

  useEffect(() => {
    GetAllOrders();
  }, [selectedSegmented]);

  useEffect(() => {
    isModalVisibleRef.current = isModalVisible;
  }, [isModalVisible]);

  async function GetAllOrders() {
    setLoadingOrders(true);
    try {
      let statusFilter = null;
      if (selectedSegmented === "Pedidos ativos") {
        statusFilter = "active";
      } else if (selectedSegmented === "Pedidos fechados") {
        statusFilter = "closed";
      }

      const response = await list_restaurant_orders_by_restaurant_id({
        restaurantId: restaurant,
        limit: 100,
        offset: 0,
        status_filter: statusFilter,
      });

      if (!response.items || response.items.length === 0) {
        setActiveOrders([]);
        setLoadingOrders(false);
        api.warning({
          message: "Nenhum pedido encontrado",
          description: "Atualmente, não há pedidos para este filtro selecionado.",
        });
        return;
      }

      let orderList = response.items;

      orderList = orderList.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      setActiveOrders(orderList);
      checkForErrorOrders(orderList);
      setLoadingOrders(false);
    } catch (error) {
      console.error(error);
      api.error({
        message: "Erro ao buscar pedidos",
        description: "Não foi possível carregar os pedidos no momento.",
      });
      setLoadingOrders(false);
    }
  }

  function checkForErrorOrders(orderList) {
    const errorOrders = orderList.filter(
      (order) =>
        order.status === "error_pdv" ||
        order.status === "error_payment"
    );

    if (errorOrders.length > 0) {
      setTimeout(() => {
        showNotificationWithSound(); 
      }, 5000);
    } else {
      if (soundInterval) {
        clearInterval(soundInterval);
        soundInterval = null;
      }
    }
  }
  const handleModalOk = () => {
    requestNotificationPermission();
    setIsModalVisible(false); 
  };

  function showNotificationWithSound() {
    console.log("chamou showNotificationWithSound ->" , Notification.permission, isModalVisibleRef); 
    if (Notification.permission === "granted" && !isModalVisibleRef.current ) {
      console.log("notificação enviada");
      const sound = new Audio("https://www.soundjay.com/buttons/sounds/button-44.mp3");
      sound.play();

      // Mostra notificação do navegador
      new Notification("Existem pedidos com erro no sistema!", {
        body: "Atualmente, existem pedidos com erro no sistema!",
        icon: "/logo.jpeg",
        badge: "/logo.jpeg",
        vibrate: [200, 100, 200],
      });

      // Mostra toast de notificação
      api.error({
        message: "Existem pedidos com erro no sistema!",
        description: "Atualmente, existem pedidos com erro no sistema!",
      });
    }
  }
  function translateOrderStatus(status) {
    switch (status) {
      case "pending":
        return "Pendente";
      case "accepted":
        return "Aceito";
      case "error_pdv":
        return "Erro no PDV";
      case "error_payment":
        return "Erro no Pagamento";
      case "preparation":
        return "Em Preparação";
      case "ready":
        return "Pronto";
      case "going":
        return "A Caminho";
      case "done":
        return "Concluído";
      case "canceled":
        return "Cancelado";
      default:
        return "Status Desconhecido";
    }
  }
  function validatedPaymentStatus(order) {
    if (!order || !order.payments || !Array.isArray(order.payments)) {
      return "Não";
    }
    console.log(order.payments);
    const isPaid = order.payments.some(
      (payment) =>
        payment.payment_type === "credit_online" &&
        payment.status === "confirmed"
    );

    return isPaid ? "Sim" : "Não";
  }

  function paymentMethod(payment) {
    switch (payment.payment_type) {
      case "cash":
        return "Dinheiro";
      case "credit":
        return "Cartão de crédito";
      case "credit_online":
        return "Cartão de crédito online";
      case "debit":
        return "Cartão de débito";
      case "debit_online":
        return "Cartão de débito online";
      case "pix":
        return "PIX";
      default:
        return "Não informado";
    }
  }

  function renderOrderItems(items) {
    if (!items || items.length === 0) {
      return <p>Nenhum item encontrado para este pedido.</p>;
    }

    return (
      <div
        style={{
          width: "100%",
        }}
      >
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              width: "100%",
              display: "flex",
              alignContent: "center",
              padding: "8px",
            }}
          >
            <div style={{ height: "auto", width: "15%" }}>
              <img
                src={item.picture ? item.picture : ""}
                alt={item.name}
                className="product-image"
              />
            </div>
            <div style={{ marginLeft: "1%" }}>
              <p>
                <strong>Nome:</strong> {item.name}
              </p>
              <p>
                <strong>Produto ID:</strong> {item.product_id}
              </p>
              <p>
                <strong>Quantidade:</strong> {item.quantity}
              </p>
              <p>
                <strong>Preço:</strong>{" "}
                {item.price != null
                  ? item.price.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })
                  : "Preço não disponível"}
              </p>
              {item.comments && (
                <p>
                  <strong>Comentários:</strong> {item.comments}
                </p>
              )}
              <br />
            </div>
            <div style={{ marginTop: "-25px", marginLeft: "2%" }}>
              {item.additionals && item.additionals.length > 0 && (
                <div className="product-additionals">
                  <h5>Adicionais:</h5>
                  {item.additionals.map((additional, i) => (
                    <div key={i} className="complement-item">
                      {additional && (
                        <div className="product-info">
                          <p>
                            <strong>Nome:</strong> {additional.name}
                          </p>
                        </div>
                      )}
                      <p>
                        <strong>Adicional ID:</strong> {additional.id}
                      </p>
                      <p>
                        <strong>Quantidade:</strong> {additional.quantity}
                      </p>
                      <p>
                        <strong>Preço:</strong>{" "}
                        {additional.price != null
                          ? additional.price.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })
                          : "Preço não disponível"}
                      </p>
                      {additional.comments && (
                        <p>
                          <strong>Comentários:</strong> {additional.comments}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div style={{ marginTop: "-25px", marginLeft: "2%" }}>
              {item.complements && item.complements.length > 0 && (
                <div className="product-complements">
                  <h5>Complementos:</h5>
                  {item.complements.map((complement, i) => (
                    <div key={i} className="complement-item">
                      {complement && (
                        <div className="product-info">
                          <p>
                            <strong>Nome:</strong> {complement.name}
                          </p>
                        </div>
                      )}
                      <p>
                        <strong>Complemento ID:</strong> {complement.id}
                      </p>
                      <p>
                        <strong>Quantidade:</strong> {complement.quantity}
                      </p>
                      <p>
                        <strong>Preço:</strong>{" "}
                        {complement.price != null
                          ? complement.price.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })
                          : "Preço não disponível"}
                      </p>
                      {complement.comments && (
                        <p>
                          <strong>Comentários:</strong> {complement.comments}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }

  function StatusSelect({ order, onUpdate }) {
    const [selectedStatus, setSelectedStatus] = useState(order.status);
    const [updating, setUpdating] = useState(false);

    const isActive = order.status !== "done" && order.status !== "canceled";

    const handleSave = async () => {
      setUpdating(true);
      try {
        await update_order({
          restaurant_order_id: order.id,
          status: selectedStatus,
        });
        onUpdate();
        api.success({
          message: "Status atualizado",
          description: `O status do pedido foi alterado para ${translateOrderStatus(
            selectedStatus
          )}.`,
        });
      } catch (error) {
        console.error("Erro ao atualizar status do pedido:", error);
        api.error({
          message: "Erro ao atualizar status",
          description: "Não foi possível atualizar o status do pedido.",
        });
      } finally {
        setUpdating(false);
      }
    };

    const statusOptions = [
      { value: "pending", label: "Pendente" },
      { value: "accepted", label: "Aceito" },
      { value: "error_pdv", label: "Erro no PDV" },
      { value: "error_payment", label: "Erro no Pagamento" },
      { value: "preparation", label: "Em Preparação" },
      { value: "ready", label: "Pronto" },
      { value: "going", label: "A Caminho" },
      { value: "done", label: "Concluído" },
      { value: "canceled", label: "Cancelado" },
    ];

    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <select
          value={selectedStatus}
          onChange={(e) => setSelectedStatus(e.target.value)}
          disabled={!isActive || updating}
          style={{ marginRight: "10px" }}
        >
          {statusOptions.map((status) => (
            <option key={status.value} value={status.value}>
              {status.label}
            </option>
          ))}
        </select>
        {isActive && (
          <Button
            text="Salvar"
            style={{ width: 50 }}
            onClick={handleSave}
            disabled={updating}
          >
            {updating ? "Salvando..." : "Salvar"}
          </Button>
        )}
      </div>
    );
  }

  return loadingOrders ? (
    <Loader />
  ) : (
    <div className="home_container">
      {contextHolder}
      <Navbar />

      <div className="body_main">
        <Modal
          title="Permissão para Notificação"
          open={isModalVisible}
          onOk={handleModalOk}
          okText="Permitir"
        >
          <p>
            Deseja permitir notificações para receber atualizações importantes?
          </p>
        </Modal>
        <div
          style={{
            height: 100,
            width: "98%",
            marginLeft: 30,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Segmented
            value={selectedSegmented}
            onChange={(e) => {
              console.log("segmented ->", e.valueOf());
              setSelectedSegmented(e.valueOf());
            }}
            style={{ backgroundColor: "transparent" }}
            options={["Pedidos ativos", "Pedidos fechados"]}
          />
        </div>
        {loadingOrders ? (
          <Loader />
        ) : (
          activeOrders.map((order) => {
            const customer = order.customer;
            const address = order.customer_address;
            return (
              <div
                key={order.id}
                style={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "white",
                  marginLeft: 30,
                }}
              >
                <h4>Informações do Pedido</h4>
                <div style={{ width: "96%" }}>
                  <p>
                    Data:{" "}
                    {order.created_at
                      ? new Date(order.created_at).toLocaleString("pt-BR", {
                          dateStyle: "short",
                          timeStyle: "short",
                        })
                      : "Data não disponível"}
                  </p>
                  <p>
                    Pedido ID:{" "}
                    {order.id != null ? order.id : "ID não disponível"}
                  </p>
                  <p>
                    Tipo de entrega:{" "}
                    {order.delivery_type === "delivery"
                      ? "Delivery"
                      : "Retirada no balcão"}
                  </p>
                  <p>
                    Status:{" "}
                    <StatusSelect order={order} onUpdate={GetAllOrders} />
                  </p>
                </div>
                <h4>Informações do Cliente</h4>
                {customer ? (
                  <div style={{ width: "96%" }}>
                    <p>Nome: {customer.name}</p>
                    <p>Email: {customer.email}</p>
                    <p>Telefone: {customer.phone}</p>
                  </div>
                ) : (
                  <p>Carregando informações do cliente...</p>
                )}
                <h4>Endereço do Cliente</h4>
                {address ? (
                  <div style={{ width: "96%" }}>
                    <p>
                      Endereço: {address.address}, {address.address_number}
                    </p>
                    {address.address_complement && (
                      <p>Complemento: {address.address_complement}</p>
                    )}
                    <p>Bairro: {address.neighborhood.neighborhood}</p>
                    <p>CEP: {address.zipcode || "Não informado"}</p>
                  </div>
                ) : (
                  <p>Carregando informações do endereço...</p>
                )}
                <h4>Itens do Pedido</h4>
                {renderOrderItems(order.items)}
                <div style={{ width: "96%", marginTop: 20 }}>
                  <p>
                    Total itens:{" "}
                    {order.total_items != null
                      ? order.total_items
                      : "Valor não disponível"}
                  </p>
                  <p>
                    Taxa de entrega:{" "}
                    {order.delivery_tax != null
                      ? order.delivery_tax.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "Valor não disponível"}
                  </p>
                  <p>
                    Total:{" "}
                    {order.total_amount != null
                      ? order.total_amount.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "Valor não disponível"}
                  </p>
                  {order.payments && order.payments.length > 0 && (
                    <div>
                      <h5>Pagamentos:</h5>
                      {order.payments.map((payment, i) => (
                        <p key={i}>
                          Valor:{" "}
                          {payment.amount != null
                            ? payment.amount.toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })
                            : "Valor não disponível"}
                          , Tipo: {paymentMethod(payment)}, Troco para:{" "}
                          {payment.change_to != null
                            ? payment.change_to.toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })
                            : "Não informado"}
                        </p>
                      ))}
                      <h5>PEDIDO PAGO: {validatedPaymentStatus(order)}</h5>
                    </div>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
